import {useEffect, useRef} from 'react';

/*
Based on https://overreacted.io/making-setinterval-declarative-with-react-hooks/

Example use:

const pauseTimer = () => setIsRunning(false);
const intervalCallback = () => setMilliseconds(milliseconds + 1);
useInterval(intervalCallback, isRunning, 1);
*/

const useInterval = (callback: Function, running: boolean, delay: number) => {
    const savedCallback = useRef<Function>();

    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        const tick = () => {
            savedCallback.current();
        };
        if (!running) return;
        const intervalId = setInterval(tick, delay);
        return () => clearInterval(intervalId);
    }, [running]);
};

export default useInterval;
